import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
//import CardHeader from '@mui/material/CardHeader';
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { CardHeader, Link } from "@mui/material";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import { SettingValidation } from "../../assets/validation/validation";
import { settingAction } from "../../redux/actions/settingAction";
import { Loader } from "../../errorPages/Loader";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  Autocomplete,
} from "@react-google-maps/api";
import { useFormik } from "formik";
import * as Yup from "yup";
import { db } from "../../configs/firebaseConfig";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";

const containerStyle = {
  width: "100%",
  height: "300px",
};

const defaultCenter = { lat: 37.7749, lng: -122.4194 }; // San Francisco

const GoogleMapComponent = ({ setCoordinates, coordinates }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCWGzggoBZ5305ZQ9y1QVVeKwctCm08N8E", // Replace with your API key
    libraries: ["places"], // Include places library for autocomplete
  });

  const mapRef = React.useRef(null);
  const markerRef = React.useRef(null);
  const autoCompleteRef = React.useRef(null);
  const [address, setAddress] = React.useState("");

  useEffect(() => {
    if (!isLoaded) return;

    const handleMarkerDragEnd = (event) => {
      const newCoords = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      setCoordinates(newCoords);
    };

    if (markerRef.current) {
      markerRef.current.addListener("dragend", handleMarkerDragEnd);
    }
  }, [isLoaded, setCoordinates]);

  const handlePlaceSelect = () => {
    const place = autoCompleteRef.current.getPlace();
    if (place && place.geometry) {
      const location = place.geometry.location;
      const newCoords = {
        lat: location.lat(),
        lng: location.lng(),
      };
      setCoordinates(newCoords);
      setAddress(place.formatted_address);
    }
  };

  if (!isLoaded) return <p>Loading map...</p>;

  return (
    <Box>
      <Autocomplete
        onLoad={(autoComplete) => (autoCompleteRef.current = autoComplete)}
        onPlaceChanged={handlePlaceSelect}
      >
        <TextField
          fullWidth
          label="Address"
          variant="outlined"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
      </Autocomplete>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={coordinates.lat ? coordinates : defaultCenter}
        zoom={12}
        onLoad={(map) => (mapRef.current = map)}
        onClick={(event) => {
          const newCoords = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };
          setCoordinates(newCoords);
        }}
        mt={5}
      >
        <Marker
          position={coordinates.lat ? coordinates : defaultCenter}
          draggable
          onDragEnd={(event) => {
            setCoordinates({
              lat: event.latLng.lat(),
              lng: event.latLng.lng(),
            });
          }}
          ref={markerRef}
        />
      </GoogleMap>
    </Box>
  );
};

export default function GeoBasedNotificationSettings() {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  /* const [data, setData] = React.useState([]);
  const [yearValue, setYearValue] = React.useState(new Date().getFullYear());
  const [urlValue, setURLValue] = React.useState("");
  const [isShowSlider, setIsShowSlider] = React.useState(false);*/
  const [coordinates, setCoordinates] = React.useState({
    lat: null,
    lng: null,
  });

  const [loading, setLoading] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      radius: "",
      //userType: true,
      //selectedDate: "",
      //timeFrom: "",
      //timeTo: "",
      enterTitle: "",
      enterDesc: "",
      exitTitle: "",
      exitDesc: "",
      alreadyUserdEntered:{}
    },
    validationSchema: Yup.object({
      radius: Yup.number()
        .required("Radius is required")
        .min(1, "Radius must be at least 1 meter"),
      /*userType: Yup.boolean().required("User type is required"),
      selectedDate: Yup.date().required("Date is required"),
      timeFrom: Yup.string().required("Start time is required"),
      timeTo: Yup.string()
        .required("End time is required")
        .test(
          "is-after",
          "End time must be after start time",
          function (value) {
            return value > this.parent.timeFrom;
          }
        ),*/
      enterTitle: Yup.string()
        .required("Enter Title is required")
        .max(100, "Enter Title cannot exceed 100 characters"),
      enterDesc: Yup.string()
        .required("Enter Description is required")
        .max(500, "Enter Description cannot exceed 500 characters"),
      exitTitle: Yup.string()
        .required("Exit Title is required")
        .max(100, "Exit Title cannot exceed 100 characters"),
      exitDesc: Yup.string()
        .required("Exit Description is required")
        .max(500, "Exit Description cannot exceed 500 characters"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      console.log("Form Submitted:", { ...values, coordinates });

      try {
        const docRef = doc(db, "geoFencedData", "settingData");
        await setDoc(docRef, { ...values, coordinates });
        console.log("Data saved successfully:", values);
        //alert("Data saved successfully!");
      } catch (error) {
        console.error("Error saving document:", error);
        alert("Failed to save data.");
      }
      setSubmitting(false);
    },
  });

  // get
  useEffect(() => {
    const fetchTitle = async () => {
      try {
        const docRef = doc(db, "geoFencedData", "settingData");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          //console.log(docSnap.data());
          const data = docSnap.data();
          formik.setValues({
            radius: data.radius || "",
            //userType: data.userType ?? true, // Ensure boolean values
            //selectedDate: data.selectedDate || "",
            //timeFrom: data.timeFrom || "",
            //timeTo: data.timeTo || "",
            enterTitle: data.enterTitle || "",
            enterDesc: data.enterDesc || "",
            exitTitle: data.exitTitle || "",
            exitDesc: data.exitDesc || "",
            alreadyUserdEntered: data.alreadyUserdEntered || ""

          });
          setCoordinates(data.coordinates);
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchTitle();
  }, []);

  /*useEffect(() => {
    dispatch(settingAction.getAll());
  }, [dispatch]);

  const { settings_data, settings_status, loading } = useSelector(
    (state) => state.settings
  );

  useEffect(() => {
    if (settings_status === true) {
      setData(settings_data);
    }
  }, [settings_status, settings_data]);*/

  /*useEffect(() => {
    if (data) {
      if (data.year) {
        setYearValue(data.year);
      }
      if (data.concessionURL) {
        setURLValue(data.concessionURL);
      }
      if (data.isShowSlider) {
        setIsShowSlider(data.isShowSlider);
      }
      if (data._id) {
        setYearId(data._id);
      }
    }
  }, [data]);*/

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      {loading ? <Loader /> : ""}
      {/* <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography className="" component={"h2"} variant="h2">
            Geo-Fenced Push Notification Settings
          </Typography>
        </Stack>
      </div> */}
      {/* <Formik
        initialValues={{
          year: yearValue,
          concessionURL: urlValue,
          isShowSlider: isShowSlider,
        }}
        validationSchema={SettingValidation}
        enableReinitialize
        onSubmit={(values, { setErrors, setSubmitting }) => {
          let form_data = {
            year: values.year,
            settingsId: yearId,
            concessionURL: values.concessionURL,
            isShowSlider: values.isShowSlider,
          };
          dispatch(settingAction.update(form_data, setErrors, setSubmitting));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
        }) => ( */}
      <form onSubmit={formik.handleSubmit}>
        <Card sx={{}} variant="outlined" className="formWrapper">
          <CardHeader
            title="Geo-Fenced Enter & Exit notification"
            action={
              <Stack direction="row" spacing={2}>
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => navigate("/geo-fenced-notifcaition")}
                  sx={{
                    fontWeight: location.pathname === "/geo-fenced-notifcaition" ? "bold" : "normal",
                    textDecoration: location.pathname === "/geo-fenced-notifcaition" ? "underline" : "none",
                  }}
                >
                  Enter & Exit notification
                </Link>
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => navigate("/geo-fenced-already-region-notifcaition")}
                  sx={{
                    fontWeight: location.pathname === "/geo-fenced-already-region-notifcaition" ? "bold" : "normal",
                    textDecoration: location.pathname === "/geo-fenced-already-region-notifcaition" ? "underline" : "none",
                  }}
                >
                  Already entered notifcaition
                </Link>
              </Stack>
            }
          />
          <CardContent>
            <Grid container spacing={0} alignItems="center">
              <Grid item lg={3} xl={3}>
                <Typography className="" component={"p"} variant="body1">
                  Select Address
                </Typography>
              </Grid>
              <Grid item lg={9} xl={9} sx={{ pr: 5 }}>
                <GoogleMapComponent
                  setCoordinates={setCoordinates}
                  coordinates={coordinates}
                />
                {coordinates.lat && (
                  <Typography variant="body2">
                    Selected: {coordinates.lat}, {coordinates.lng}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}></Grid>
            </Grid>

            <Grid container spacing={0} mt={2} alignItems="center">
              {/* Radius Input */}
              <Grid item lg={3} xl={3} mt={2}>
                <Typography component="p" variant="body1">
                  Radius (Meters)
                </Typography>
              </Grid>
              <Grid item lg={4} xl={4} mt={2} sx={{ pr: 5 }}>
                <TextField
                  fullWidth
                  label="Radius"
                  name="radius"
                  type="number"
                  {...formik.getFieldProps("radius")}
                  error={formik.touched.radius && Boolean(formik.errors.radius)}
                  helperText={formik.touched.radius && formik.errors.radius}
                  variant="outlined"
                  required
                  InputLabelProps={{ required: true }}
                />
              </Grid>
            </Grid>

            {/* <Grid container spacing={0} mt={2} alignItems="center">
                  <Grid item lg={3} xl={3}>
                    <Typography className="" component={"p"} variant="body1">
                      Users type
                    </Typography>
                  </Grid>
                  <Grid item lg={4} xl={4} sx={{ pr: 5 }}>
                    <TextField
                      select
                      fullWidth
                      label="Users"
                      name="userType"
                      {...formik.getFieldProps("userType")}
                      error={
                        formik.touched.userType &&
                        Boolean(formik.errors.userType)
                      }
                      helperText={
                        formik.touched.userType &&
                        formik.errors.userType
                      }
                      variant="outlined"
                      required
                      InputLabelProps={{ required: true }}
                    >
                      <MenuItem value={true}>Within Radius</MenuItem>
                      <MenuItem value={false}>Outside Radius</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>*/}

            <Grid container spacing={0} mt={2} alignItems="center">
              {/* Message Title */}
              <Grid item lg={3} xl={3}>
                <Typography component="p" variant="body1">
                  Message Enter Title
                </Typography>
              </Grid>
              <Grid item lg={9} xl={9} sx={{ pr: 5 }}>
                <TextField
                  fullWidth
                  name="enterTitle"
                  label="Enter Title"
                  {...formik.getFieldProps("enterTitle")}
                  error={
                    formik.touched.enterTitle &&
                    Boolean(formik.errors.enterTitle)
                  }
                  helperText={
                    formik.touched.enterTitle && formik.errors.enterTitle
                  }
                  variant="outlined"
                  required
                />
              </Grid>
            </Grid>

            <Grid container spacing={0} mt={2} alignItems="center">
              {/* Message Description */}
              <Grid item lg={3} xl={3} mt={2}>
                <Typography component="p" variant="body1">
                  Message Enter Description
                </Typography>
              </Grid>
              <Grid item lg={9} xl={9} mt={2} sx={{ pr: 5 }}>
                <TextField
                  fullWidth
                  name="enterDesc"
                  label="Enter Description"
                  {...formik.getFieldProps("enterDesc")}
                  error={
                    formik.touched.enterDesc && Boolean(formik.errors.enterDesc)
                  }
                  helperText={
                    formik.touched.enterDesc && formik.errors.enterDesc
                  }
                  variant="outlined"
                  multiline
                  rows={3}
                  required
                />
              </Grid>
            </Grid>

            <Grid container spacing={0} mt={2} alignItems="center">
              {/* Message Title */}
              <Grid item lg={3} xl={3}>
                <Typography component="p" variant="body1">
                  Message Exit Title
                </Typography>
              </Grid>
              <Grid item lg={9} xl={9} sx={{ pr: 5 }}>
                <TextField
                  fullWidth
                  name="exitTitle"
                  label="Exit Title"
                  {...formik.getFieldProps("exitTitle")}
                  error={
                    formik.touched.exitTitle && Boolean(formik.errors.exitTitle)
                  }
                  helperText={
                    formik.touched.exitTitle && formik.errors.exitTitle
                  }
                  variant="outlined"
                  required
                />
              </Grid>
            </Grid>

            <Grid container spacing={0} mt={2} alignItems="center">
              {/* Message Description */}
              <Grid item lg={3} xl={3} mt={2}>
                <Typography component="p" variant="body1">
                  Message Exit Description
                </Typography>
              </Grid>
              <Grid item lg={9} xl={9} mt={2} sx={{ pr: 5 }}>
                <TextField
                  fullWidth
                  name="exitDesc"
                  label="Exit Description"
                  {...formik.getFieldProps("exitDesc")}
                  error={
                    formik.touched.exitDesc && Boolean(formik.errors.exitDesc)
                  }
                  helperText={formik.touched.exitDesc && formik.errors.exitDesc}
                  variant="outlined"
                  multiline
                  rows={3}
                  required
                />
              </Grid>
            </Grid>

            {/* <Grid container spacing={0} mt={2} alignItems="center">
              <Grid item lg={3} xl={3}>
                <Typography component="p" variant="body1">
                  Select Date
                </Typography>
              </Grid>
              <Grid item lg={4} xl={4} sx={{ pr: 5 }}>
                <TextField
                  fullWidth
                  label="Date"
                  name="selectedDate"
                  type="date"
                  {...formik.getFieldProps("selectedDate")}
                  error={
                    formik.touched.selectedDate &&
                    Boolean(formik.errors.selectedDate)
                  }
                  helperText={
                    formik.touched.selectedDate && formik.errors.selectedDate
                  }
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  required
                />
              </Grid>
            </Grid>
            <Grid container spacing={0} mt={2} alignItems="center">
              <Grid item lg={3} xl={3}>
                <Typography component="p" variant="body1">
                  Select Time
                </Typography>
              </Grid>
              <Grid item lg={4} xl={4} sx={{ pr: 5, display: "flex", gap: 2 }}>
                <TextField
                  fullWidth
                  name="timeFrom"
                  type="time"
                  label="From"
                  {...formik.getFieldProps("timeFrom")}
                  error={
                    formik.touched.timeFrom && Boolean(formik.errors.timeFrom)
                  }
                  helperText={formik.touched.timeFrom && formik.errors.timeFrom}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  required
                />
                <Typography
                  component="p"
                  variant="body1"
                  sx={{ alignSelf: "center" }}
                >
                  -
                </Typography>
                <TextField
                  fullWidth
                  name="timeTo"
                  type="time"
                  label="To"
                  {...formik.getFieldProps("timeTo")}
                  error={formik.touched.timeTo && Boolean(formik.errors.timeTo)}
                  helperText={formik.touched.timeTo && formik.errors.timeTo}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  required
                />
              </Grid>
            </Grid> */}
          </CardContent>
          <CardActions sx={{ justifyContent: "center" }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? <CircularProgress size={20} /> : "Save"}
            </Button>
            {/* <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {" "}
                  {isSubmitting ? <CircularProgress size={20} /> : "Save"}
                </Button> */}
            {/* <Button type="button" variant="contained" color="secondary"
                        onClick={(e) => {    
                            handleReset();
                            //navigate(-1);
                        }}
                        >Cancel</Button> */}
          </CardActions>
        </Card>
      </form>
      {/* )}
      </Formik> */}
    </Box>
  );
}
